module.exports = __webpack_public_path__ + "img/circle.58c220f7.svg";